import { Container, Sprite, TextStyle, Text, NineSliceSprite, Point } from 'pixi.js';
import { getAsset } from './preloadGameAssets';
import { addToLevel } from './core/Playable2DRootContainer';
import { getScreenSize } from './core/screen';
import { MonoBehavior } from './core/monoBehavior';
import { Layout } from './LayoutManager';
import gsap from 'gsap';
import { translate } from './translate';
import { Displays } from 'constants/layout';

const style = new TextStyle({
    textBaseline: 'bottom',
    fontFamily: 'Inter',
    fill: '#000000',
    fontSize: 80,
    wordWrap: true,
    wordWrapWidth: 900,
    lineHeight: 70,
});
addEventListener('kingPopup', (e: CustomEvent) => {
    new KingPopup(e.detail);
});
export class KingPopup extends MonoBehavior {
    container: Container;
    textArea: Text;
    cloudContainer: Container;
    kingSprite?: Sprite;

    constructor(textKey: string) {
        super();
        this.container = new Container();
        this.container.alpha = 0;
        this.textArea = new Text({
            text: translate(textKey),
            style,
        });
        this.textArea.anchor.set(0, 1);
        this.cloudContainer = new Container();

        this.loadAssets();

        this.container.addChild(this.cloudContainer);
    }
    async loadAssets() {
        const cloud = await getAsset('kingPopup/cloud');
        const king = await getAsset('kingPopup/king');
        const kingSprite = new Sprite(king);
        kingSprite.anchor.set(0, 1);
        addToLevel(this.container);
        this.container.addChild(kingSprite);
        this.kingSprite = kingSprite;

        this.setPosition();

        const cloudSprite = new NineSliceSprite({
            texture: cloud,
            leftWidth: 190,
            topHeight: 100,
            rightWidth: 100,
            bottomHeight: 132,
            width: this.textArea.width + 350,
            height: Math.max(230, this.textArea.height + 160),
        });
        this.cloudContainer.addChild(cloudSprite);
        this.cloudContainer.addChild(this.textArea);

        cloudSprite.position.set(-240, cloudSprite.height * -1);

        this.show();
    }

    show() {
        gsap.to(this.container, {
            alpha: 1,
            duration: 0.5, // 0.5 seconds
        }).then(() => {
            gsap.to(this.container, {
                alpha: 0,
                duration: 0.5, // 0.5 seconds
                delay: 5,
            }).then(() => {
                this.destroy();
            });
        });
    }
    setPosition() {
        const cardSize = Layout.getCardSize();
        const { width, height } = getScreenSize();
        switch (Layout.getDisplay()) {
            case Displays.DESKTOP:
                this.cloudContainer.position.set(800, -365);
                this.cloudContainer.scale.set(1.1);
                this.container.scale.set(cardSize.width / 460);

                this.textArea.style.fontSize = 80;
                this.textArea.style.wordWrapWidth = 1200;
                this.textArea.style.lineHeight = 80;
                this.textArea.position.set(-15, -92);
                this.kingSprite?.position.set(50, 0);
                break;
            case Displays.TABLET:
                this.cloudContainer.position.set(674, -420);
                this.cloudContainer.scale.set(0.6);
                this.container.scale.set(cardSize.width / 300);

                this.textArea.style.fontSize = 80;
                this.textArea.style.wordWrapWidth = 900;
                this.textArea.style.lineHeight = 80;
                this.textArea.position.set(-15, -90);

                this.kingSprite?.position.set(33, 0);

                break;
            case Displays.MOBILE:
                this.cloudContainer.position.set(674, -350);
                this.cloudContainer.scale.set(0.9);
                this.container.scale.set(cardSize.width / 210);

                this.textArea.style.fontSize = 80;
                this.textArea.style.wordWrapWidth = width * 2;
                this.textArea.style.lineHeight = 80;
                this.textArea.position.set(-15, -90);

                this.kingSprite?.position.set(-26, 12);
                break;
        }
    }

    destroy() {
        super.destroy();
        this.textArea.destroy();
        this.cloudContainer.destroy();
        this.cloudContainer.removeChildren();
        this.container.removeChildren();
        this.container.destroy();
    }
    resize(width: number, height: number): void {
        const cardSize = Layout.getCardSize();
        this.container.position.set(-width / 2, height / 2 + cardSize.height * 0.12);
    }
}
